module.exports = __webpack_public_path__ + "img/laboratorio2_9-16_810.d6bd4aa2.webp";